import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/metro_nn"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47141 6.47146C3.47141 3.97041 5.49891 1.94291 7.99996 1.94291C10.501 1.94291 12.5285 3.97041 12.5285 6.47146C12.5285 7.25823 12.3279 7.99813 11.975 8.64281L10.848 6.47146L8.08007 9.62923L5.3121 6.47146L4.08471 8.74857C3.69479 8.07959 3.47141 7.30161 3.47141 6.47146ZM3.57622 9.69194C2.91732 8.78841 2.5285 7.67534 2.5285 6.47146C2.5285 3.44965 4.97816 1 7.99996 1C11.0218 1 13.4714 3.44965 13.4714 6.47146C13.4714 7.64112 13.1044 8.72507 12.4792 9.6144L15 14.4715H10.848L9.46406 12.1555L8.08007 14.4715L6.69609 12.1555L5.15196 14.4715H1L3.57622 9.69194Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { MetroNn16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var MetroNn16 = createIcon(IconComponent);